import { useContext } from 'react';

import { FormState, StandardInputsState } from './_types';
import { StandardInputsContext } from './context';

export const useInputs = <T extends FormState>() => {
  return useContext(StandardInputsContext) as unknown as StandardInputsState<T>;
};
